<template>
    <div class="slider">
        <div class="row justify-content-center" v-if="!initializing">
            <div class="col-8 col-lg-6">
                {{ $t("footer.dismissHint")}}
            </div>
            <div class="col-4 col-lg-6 text-right">
                <MJSliderButtonAndroid @input="updateValue" v-if="isAndroid"></MJSliderButtonAndroid>
                <MJSliderButton @input="updateValue" v-else></MJSliderButton>
            </div>
        </div>
    </div>
</template>

<script>
    import MJSliderButton from "./MJSliderButton";
    import MJSliderButtonAndroid from "./MJSliderButtonAndroid";
    export default {
        name: "MJSlider",
        components: {MJSliderButton, MJSliderButtonAndroid},
        data() {
            return {
                initializing: true,
                isAndroid: false
            }
        },
        async beforeMount() {
            this.isAndroid = (await this.$communicator.getDeviceType()) === "Android";
            this.initializing = false;
        },
        methods: {
            updateValue(value) {
                this.$emit("input", value);
            }
        }
    }
</script>

<style scoped>
    .slider {
        font-size: 15px;
        color: rgb(102, 102, 102);
    }
</style>